<template lang="html">
  <v-list-item>
    <v-list-item-avatar class="rounded-0" width="40" height="40">
      <img src="@/assets/ts3_manager_logo.svg" />
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>TS Server Manager</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {};
</script>
